import React, { useMemo } from 'react';
import { block } from '../utils/cn';
import { TabsItem } from './TabsItem';
import './Tabs.css';
const b = block('tabs');
export var TabsDirection;
(function (TabsDirection) {
    TabsDirection["Horizontal"] = "horizontal";
    TabsDirection["Vertical"] = "vertical";
})(TabsDirection || (TabsDirection = {}));
export const Tabs = ({ direction = TabsDirection.Horizontal, size = 'm', activeTab, allowNotSelected = false, items = [], className, onSelectTab, wrapTo, qa, }) => {
    const activeTabId = useMemo(() => {
        if (activeTab) {
            return activeTab;
        }
        if (allowNotSelected || items.length === 0) {
            return undefined;
        }
        return items[0].id;
    }, [activeTab, allowNotSelected, items]);
    const handleTabClick = (tabId) => {
        if (onSelectTab) {
            onSelectTab(tabId);
        }
    };
    return (React.createElement("div", { role: "tablist", className: b({ direction, size }, className), "data-qa": qa }, items.map((item, index) => {
        const tabItemNode = (React.createElement(TabsItem, Object.assign({ key: item.id }, item, { active: item.id === activeTabId, onClick: handleTabClick })));
        if (wrapTo) {
            return wrapTo(item, tabItemNode, index);
        }
        return tabItemNode;
    })));
};
